module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purchaseSalesDate"
    }
  }, [_vm._v("Damage Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('input-mask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "damageNo"
    }
  }, [_vm._v("Damage No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "damageNo",
      "disabled": ""
    },
    model: {
      value: (_vm.damageNo),
      callback: function($$v) {
        _vm.damageNo = $$v
      },
      expression: "damageNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "referenceNumber"
    }
  }, [_vm._v("Ref No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "refNO"
    },
    model: {
      value: (_vm.referenceNumber),
      callback: function($$v) {
        _vm.referenceNumber = $$v
      },
      expression: "referenceNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    staticClass: "dropDown",
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    staticClass: "dropDown",
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px !important"
          }
        }, [_vm._v(_vm._s(slotProps.item.name) + " - " + _vm._s(slotProps.item.itemCode))])]
      }
    }]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 align-self-end"
  }, [_c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5",
    on: {
      "set_data_item": _vm.set_data_item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Sales Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00')\n                              this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00')\n                              this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00')\n                              this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button p-component addNewBtn btn-btm-0",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTO.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editDTO) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "id": "action",
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.itemDTOreset.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.totalAmount) + _vm._s(_vm.findRate) + _vm._s(_vm.setRateFromItem))]), _vm._v(" "), (_vm.items.closingStock >= 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('label', {
    attrs: {
      "for": "avlQty"
    }
  }, [_vm._v("Cur. Stock: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.items.closingStock))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered "
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rate * item.quantity) + " ")]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.deleteItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1)])])
  })], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "16em"
    }
  }, [_vm._v(_vm._s(_vm.totalQty))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "38em"
    }
  }, [_vm._v(_vm._s(_vm.subTotal))])])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "6"
    },
    model: {
      value: (_vm.narration),
      callback: function($$v) {
        _vm.narration = $$v
      },
      expression: "narration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "id": "imageUpload",
      "label": "Upload Image"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showItemUpload.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('InputText', {
    model: {
      value: (_vm.linkUrl),
      callback: function($$v) {
        _vm.linkUrl = $$v
      },
      expression: "linkUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": !_vm.editing ? 'Save' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSalesOrder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [(_vm.damage == undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-warning",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [(_vm.damage != undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-print",
      "label": "Print"
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-print",
      "label": "Print",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download"
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "label": "Generate PDF",
      "icon": "pi pi-download",
      "disabled": ""
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "item"
    }
  }, [_vm._v("Item"), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('b', {
    staticStyle: {
      "margin-left": "15em"
    }
  }, [_vm._v("Total:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f082c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/sales/damage.vue
// module id = 2305
// module chunks = 0